import { RowData, RowDataReducerState } from "../types";
import {
  MOCK_ACCOUNTS_PAYABLE_SCHEMA,
  MOCK_ACCOUNTS_PAYABLE_ROW_DATA,
  MOCK_ACCOUNTS_PAYABLE_ROW_DATA_LIST,
  MOCK_ACCOUNTS_PAYABLE_COL_DEFS,
  MOCK_JOURNALS_SCHEMA,
  MOCK_JOURNALS_ROW_DATA,
  MOCK_JOURNALS_ROW_DATA_LIST,
  MOCK_JOURNALS_COL_DEFS,
  MOCK_ACCOUNTS_RECEIVABLE_SCHEMA,
  MOCK_ACCOUNTS_RECEIVABLE_ROW_DATA,
  MOCK_ACCOUNTS_RECEIVABLE_ROW_DATA_LIST,
  MOCK_CASH_IN_BANK_SCHEMA,
  MOCK_CASH_IN_BANK_ROW_DATA,
  MOCK_CASH_IN_BANK_ROW_DATA_LIST,
  MOCK_CASH_RECEIPT_PAYMENT_TYPES_SCHEMA,
  MOCK_CASH_RECEIPT_PAYMENT_TYPES_ROW_DATA,
  MOCK_CASH_RECEIPT_PAYMENT_TYPES_COL_DEFS,
  MOCK_INTERCO_TRANSFER_SCHEMA,
  MOCK_INTERCO_TRANSFERS_ROW_DATA,
  MOCK_EXPENSE_ALLOCATION_SCHEMA,
  MOCK_EXPENSE_ALLOCATIONS_ROWDATA,
  MOCK_SALES_CHAIN_SCHEMA,
  MOCK_SALES_CHAIN_ROWDATA,
  MOCK_SALES_CHAIN_COLUMNDEFS,
  MOCK_RECCUREING_JOURNAL_ENTRIES_SCHEMA,
  MOCK_RECCUREING_JOURNAL_ENTRIES_ROWDATA,
  MOCK_CHART_OF_ACCOUNTS_ROW_DATA,
  MOCK_CHART_OF_ACCOUNTS_SCHEMA,
  MOCK_GROUP_CODES_SCHEMA,
  MOCK_GROUP_CODES_ROWDATA,
  MOCK_LASER_FORM_TABLE_SCHEMA,
  MOCK_LASER_FORM_TABLE_ROWDATA,
  MOCK_GROUP_CODES_COULUMNS,
  MOCK_GLFiscalYearCalendar_Schema,
  MOCK_GLFiscalYearCalendar_ROWDATA,
  MOCK_GLFiscalYearCalendar_Coldefs,
  MOCK_WRITE_OFFS_SCHEMA,
  MOCK_WRITE_OFFS_ROWDATA,
  MOCK_PO_CONFIGURATION_GROUP_SCHEMA,
  MOCK_PO_CONFIGURATION_GROUP_ROW_DATA,
  MOCK_PO_CONFIGURATION_GROUP_ROW_DATA_LIST,
  MOCK_PO_UNIT_OF_MEASURE_SCHEMA,
  MOCK_PO_UNITS_OF_MEASURE_ROWDATA,
  MOCK_PO_UNITS_OF_MEASURE_COLDEFS,
  MOCK_VENDOR_CONFIGURATION_GROUP_SCHEMA,
  VENDOR_SETUPS_CONFIGURATION_ROWDATA,
  VENDOR_SETUPS_CONFIGURATION_ROWDATALIST,
  MOCK_DISCOUNTS_SCHEMA,
  MOCK_DISCOUNTS_ROW_DATA,
  MOCK_DEFAULT_LABOR_TYPES_SCHEMA,
  MOCK_DEFAULT_LABOR_TYPES_ROW_DATA,
  MOCK_SHOP_CHARGES_SCHEMA,
  MOCK_SHOP_CHARGES_ROWDATA,
  MOCK_BANK_RECON_SCHEMA,
  MOCK_BANK_RECON_ROWDATA,
  MOCK_PRICING_MATRIX_SCHEMA,
  MOCK_PRICING_MATRIX_ROWDATA_LIST,
} from "../pages/LandingPage/MockData";

export const DEFAULT_INITIAL_ROW_DATA_REDUCER_STATE: RowDataReducerState = {
  schema: {
    $schema: "",
    $id: "",
    title: "",
    description: "",
    properties: {},
    required: [],
    sections: {},
  },
  rowData: {},
  rowDataList: [],
  columnDefs: [],
  rowDataErrors: {},
  deletedObjectsList: {},
  resetState: {
    schema: {
      $schema: "",
      $id: "",
      title: "",
      description: "",
      properties: {},
      required: [],
      sections: {},
    },
    rowData: {},
  },
};

export const MOCK_ACCOUNTS_PAYABLE_INITIAL_ROW_DATA: RowData = {
  accounts_payable_store: "",
  accounts_payable_company: "",
  accounts_payable_account: "",
  reference_flag: null,
  share_check_number: "Same check forms number series as CHK",
  close_requires_schedules: true,
  is_vendor_editable: null,
  retention_months: 28,
  temp_account_payable_company: null,
  temp_account_payable_account: null,
  check_date_format: null,
  reuse_check_number_password: null,
  cash_disbursement: [
    {
      ref_store: "",
      ref_company: "",
      ref_journal: "",
      active_status: "active",
    },
  ],
  cash_in_bank: [
    {
      ref_store: "",
      ref_company: "",
      ref_account: "",
      active_status: "active",
    },
  ],
  trade_discount: [
    {
      ref_store: "",
      ref_company: "",
      ref_account: "",
      active_status: "active",
    },
  ],
  purchase_journal: [
    {
      ref_store: "",
      ref_company: "",
      ref_number: "",
      active_status: "active",
    },
  ],
};

export const MOCK_PO_CONFIGURATION_GROUP_DEFAULT_INTIAL_ROW_DATA: RowData = {
  poGroupTab: {
    po_group_cd: "",
    po_group_desc: "",
    acc_name: "",
    converted_sw: false,
    max_po_nbr_length_qty: null,
    default_dealer_address_id: null,
    description: false,
    dealer_nm: null,
    include_alternate_shipping_sw: false,
    allow_po_nbr_assignment_sw: false,
    temp_vendor_address: false,
    active_sw: true,
    po_nbr_prefix_cd: null,
    po_start_nbr: "",
    po_next_nbr: "",
    po_end_nbr: null,
    require_requestor_sw: false,
    require_ship_via_sw: false,
    require_header_comment_sw: false,
    require_detail_comment_sw: false,
    edit_approved_po_sw: false,
    require_modification_reason_sw: false,
    variance_amt: 0,
    use_receiving_sw: false,
    use_preinvoicing_sw: false,
    history_retention_months_qty: null,
    auto_archive_sw: false,
    auto_archive_months_qty: null,
    set_inactive_pos_sw: false,
    inactive_weeks_qty: null,
    standard_form_sw: true,
    language_cd: "ENG",
  },
  poAccountsTab: {
    group_accounts: [],
    group_stores: [
      {
        store_id: "",
        company_id: "",
        active_status: "active",
      },
    ],
    ref_store: "",
    ref_company: "",
    ref_account: "",
  },
  poAddressTab: {
    group_addresses: [
      {
        addr_nm: "",
        addr_line1: "",
        addr_line2: null,
        city_nm: "",
        county_nm: null,
        state_cd: "",
        country_cd: "",
        postal_cd: "",
        addr_type: "",
        is_default_address: false,
        area_cd: null,
        phone_nbr: "",
        phone_ext_nbr: null,
        phone_country_cd: "",
        phone_type: "",
        active_status: "active",
      },
    ],
  },
  shipViasTab: {
    shipVias: [
      {
        ship_via_cd: "",
        ship_via_desc: "",
        active_status: "active",
      },
    ],
  },
  poTypesTab: {
    poTypes: [
      {
        po_type_cd: "",
        po_type_desc: "",
        po_nbr_on_create_sw: false,
        validate_item_cat_sw: false,
        doc_nbr_required_id: null,
        po_type_category: "Miscellaneous",
        base_type_sw: false,
        temp_vendor_sw: false,
        gl_coa_account: null,
        dms_po_type_id: null,
        last_modified_po_user_id: null,
        active_sw: true,
        last_modified_dt: null,
        use_receiving_sw: false,
        use_preinvoicing_sw: false,
        active_status: "active",
      },
    ],
  },
};

export const MOCK_CASH_RECEIPT_PAYMENT_TYPES_INITIAL_ROW_DATA: RowData = {
  payment_types: [],
};

export const MOCK_ACCOUNTS_PAYABLE_ROW_DATA_REDUCER_STATE: RowDataReducerState =
  {
    schema: MOCK_ACCOUNTS_PAYABLE_SCHEMA,
    rowData: MOCK_ACCOUNTS_PAYABLE_ROW_DATA,
    rowDataList: MOCK_ACCOUNTS_PAYABLE_ROW_DATA_LIST,
    columnDefs: MOCK_ACCOUNTS_PAYABLE_COL_DEFS,
    rowDataErrors: {},
    deletedObjectsList: {},
    resetState: {
      schema: MOCK_ACCOUNTS_PAYABLE_SCHEMA,
      rowData: MOCK_ACCOUNTS_PAYABLE_ROW_DATA,
    },
    isReadOnly: false,
  };

export const MOCK_JOURNALS_ROW_DATA_REDUCER_STATE: RowDataReducerState = {
  schema: MOCK_JOURNALS_SCHEMA,
  rowData: MOCK_JOURNALS_ROW_DATA,
  rowDataList: MOCK_JOURNALS_ROW_DATA_LIST,
  columnDefs: MOCK_JOURNALS_COL_DEFS,
  rowDataErrors: {},
  deletedObjectsList: {},
  resetState: {
    schema: MOCK_JOURNALS_SCHEMA,
    rowData: MOCK_JOURNALS_ROW_DATA,
  },
};

export const MOCK_CHART_OF_ACCOUNTS_ROW_DATA_REDUCER_STATE: RowDataReducerState =
  {
    schema: MOCK_CHART_OF_ACCOUNTS_SCHEMA,
    rowData: MOCK_CHART_OF_ACCOUNTS_ROW_DATA,
    rowDataList: Array(30).fill(MOCK_CHART_OF_ACCOUNTS_ROW_DATA),
    columnDefs: [],
    rowDataErrors: {},
    deletedObjectsList: {},
  };

export const MOCK_ACCOUNTS_RECEIVABLE_ROW_DATA_REDUCER_STATE: RowDataReducerState =
  {
    schema: MOCK_ACCOUNTS_RECEIVABLE_SCHEMA,
    rowData: MOCK_ACCOUNTS_RECEIVABLE_ROW_DATA,
    rowDataList: MOCK_ACCOUNTS_RECEIVABLE_ROW_DATA_LIST,
    columnDefs: [],
    rowDataErrors: {},
    deletedObjectsList: {},
  };

export const MOCK_CASH_IN_BANK_ROW_DATA_REDUCER_STATE: RowDataReducerState = {
  schema: MOCK_CASH_IN_BANK_SCHEMA,
  rowData: MOCK_CASH_IN_BANK_ROW_DATA,
  rowDataList: MOCK_CASH_IN_BANK_ROW_DATA_LIST,
  columnDefs: [],
  rowDataErrors: {},
  deletedObjectsList: {},
};

export const MOCK_CASH_RECEIPT_PAYMENT_TYPES_REDUCER_STATE: RowDataReducerState =
  {
    schema: MOCK_CASH_RECEIPT_PAYMENT_TYPES_SCHEMA,
    rowData: MOCK_CASH_RECEIPT_PAYMENT_TYPES_ROW_DATA,
    rowDataList: [MOCK_CASH_RECEIPT_PAYMENT_TYPES_ROW_DATA],
    columnDefs: MOCK_CASH_RECEIPT_PAYMENT_TYPES_COL_DEFS,
    rowDataErrors: {},
    deletedObjectsList: {},
  };

export const MOCK_INTERCO_TRANSFERS_REDUCER_STATE: RowDataReducerState = {
  schema: MOCK_INTERCO_TRANSFER_SCHEMA,
  rowData: MOCK_INTERCO_TRANSFERS_ROW_DATA,
  rowDataList: [MOCK_INTERCO_TRANSFERS_ROW_DATA],
  columnDefs: [],
  rowDataErrors: {},
  deletedObjectsList: {},
};

export const MOCK_EXPENSE_ALLOCATIONS_ROW_DATA_REDUCER_STATE: RowDataReducerState =
  {
    schema: MOCK_EXPENSE_ALLOCATION_SCHEMA,
    rowData: MOCK_EXPENSE_ALLOCATIONS_ROWDATA,
    rowDataList: [MOCK_EXPENSE_ALLOCATIONS_ROWDATA],
    columnDefs: [],
    rowDataErrors: {},
    deletedObjectsList: {},
  };

export const MOCK_RECCUREING_JOURNAL_ENTRIES_REDUCER_STATE: RowDataReducerState =
  {
    schema: MOCK_RECCUREING_JOURNAL_ENTRIES_SCHEMA,
    rowData: MOCK_RECCUREING_JOURNAL_ENTRIES_ROWDATA,
    rowDataList: [MOCK_RECCUREING_JOURNAL_ENTRIES_ROWDATA],
    columnDefs: [],
    rowDataErrors: {},
    deletedObjectsList: {},
  };

export const MOCK_SALES_CHAINS_ROW_DATA_REDUCER_STATE: RowDataReducerState = {
  schema: MOCK_SALES_CHAIN_SCHEMA,
  rowData: MOCK_SALES_CHAIN_ROWDATA,
  rowDataList: [MOCK_SALES_CHAIN_ROWDATA],
  columnDefs: MOCK_SALES_CHAIN_COLUMNDEFS,
  rowDataErrors: {},
  deletedObjectsList: {},
};

export const MOCK_GROUP_CODES_ROW_DATA_REDUCER_STATE: RowDataReducerState = {
  schema: MOCK_GROUP_CODES_SCHEMA,
  rowData: MOCK_GROUP_CODES_ROWDATA,
  rowDataList: [MOCK_GROUP_CODES_ROWDATA],
  columnDefs: MOCK_GROUP_CODES_COULUMNS,
  rowDataErrors: {},
  deletedObjectsList: {},
};

export const MOCK_LASER_FORM_TABLE_ROW_DATA_REDUCER_STATE: RowDataReducerState =
  {
    schema: MOCK_LASER_FORM_TABLE_SCHEMA,
    rowData: MOCK_LASER_FORM_TABLE_ROWDATA,
    rowDataList: [MOCK_LASER_FORM_TABLE_ROWDATA],
    columnDefs: [],
    rowDataErrors: {},
    deletedObjectsList: {},
  };

export const MOCK_GLFiscalYearCalendar_ROW_DATA_REDUCER_STATE: RowDataReducerState =
  {
    schema: MOCK_GLFiscalYearCalendar_Schema,
    rowData: MOCK_GLFiscalYearCalendar_ROWDATA,
    rowDataList: [MOCK_GLFiscalYearCalendar_ROWDATA],
    columnDefs: MOCK_GLFiscalYearCalendar_Coldefs,
    rowDataErrors: {},
    deletedObjectsList: {},
  };

export const MOCK_WRITE_OFFS_ROWDATA_REDUCER_STATE: RowDataReducerState = {
  schema: MOCK_WRITE_OFFS_SCHEMA,
  rowData: MOCK_WRITE_OFFS_ROWDATA,
  rowDataList: [MOCK_WRITE_OFFS_ROWDATA],
  columnDefs: [],
  rowDataErrors: {},
  deletedObjectsList: {},
};

export const MOCK_PO_CONFIGURATION_GROUP_ROWDATA_REDUCER_STATE: RowDataReducerState =
  {
    schema: MOCK_PO_CONFIGURATION_GROUP_SCHEMA,
    rowData: MOCK_PO_CONFIGURATION_GROUP_ROW_DATA,
    rowDataList: MOCK_PO_CONFIGURATION_GROUP_ROW_DATA_LIST,
    columnDefs: [],
    rowDataErrors: {},
    deletedObjectsList: {},
  };

export const MOCK_PO_UNITS_OF_MEASURE_ROWDATA_REDUCER_STATE: RowDataReducerState =
  {
    schema: MOCK_PO_UNIT_OF_MEASURE_SCHEMA,
    rowData: MOCK_PO_UNITS_OF_MEASURE_ROWDATA,
    rowDataList: [MOCK_PO_UNITS_OF_MEASURE_ROWDATA],
    columnDefs: MOCK_PO_UNITS_OF_MEASURE_COLDEFS,
    rowDataErrors: {},
    deletedObjectsList: {},
  };

export const MOCK_VENDOR_CONFIGURATION_GROUP_ROWDATA_REDUCER_STATE: RowDataReducerState =
  {
    schema: MOCK_VENDOR_CONFIGURATION_GROUP_SCHEMA,
    rowData: VENDOR_SETUPS_CONFIGURATION_ROWDATA,
    rowDataList: VENDOR_SETUPS_CONFIGURATION_ROWDATALIST,
    columnDefs: [],
    rowDataErrors: {},
    deletedObjectsList: {},
  };

export const MOCK_DISCOUNTS_ROW_DATA_REDUCER_STATE: RowDataReducerState = {
  schema: MOCK_DISCOUNTS_SCHEMA,
  rowData: MOCK_DISCOUNTS_ROW_DATA,
  rowDataList: [MOCK_DISCOUNTS_ROW_DATA],
  columnDefs: [],
  rowDataErrors: {},
  deletedObjectsList: {},
};

export const MOCK_DEFAULT_LABOR_TYPES_ROW_DATA_REDUCER_STATE: RowDataReducerState =
  {
    schema: MOCK_DEFAULT_LABOR_TYPES_SCHEMA,
    rowData: MOCK_DEFAULT_LABOR_TYPES_ROW_DATA,
    rowDataList: [MOCK_DEFAULT_LABOR_TYPES_ROW_DATA],
    columnDefs: [],
    rowDataErrors: {},
    deletedObjectsList: {},
  };

export const MOCK_SHOP_CHARGE_ROW_DATA_REDUCER_STATE: RowDataReducerState = {
  schema: MOCK_SHOP_CHARGES_SCHEMA,
  rowData: MOCK_SHOP_CHARGES_ROWDATA,
  rowDataList: [MOCK_SHOP_CHARGES_ROWDATA],
  columnDefs: [],
  rowDataErrors: {},
  deletedObjectsList: {},
};

export const MOCK_BANK_RECON_ROW_DATA_REDUCER_STATE: RowDataReducerState = {
  schema: MOCK_BANK_RECON_SCHEMA,
  rowData: MOCK_BANK_RECON_ROWDATA,
  rowDataList: [MOCK_BANK_RECON_ROWDATA],
  columnDefs: [],
  rowDataErrors: {},
  deletedObjectsList: {},
};

export const MOCK_PRICING_MATRIX_ROWDATA_REDUCER_STATE: RowDataReducerState = {
  schema: MOCK_PRICING_MATRIX_SCHEMA,
  rowData: MOCK_PRICING_MATRIX_ROWDATA_LIST[0],
  rowDataList: MOCK_PRICING_MATRIX_ROWDATA_LIST,
  columnDefs: [],
  rowDataErrors: {},
  deletedObjectsList: {},
};
